import React, {FunctionComponent} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCheck} from "@fortawesome/free-solid-svg-icons";

interface StepperStepProps {
    text?: string;
    completed?: boolean;
    active?: boolean;
    stepIcon?: React.ReactNode;
}

/**
 * Component to use as children in the stepper component, that defines everything about one step.
 * @param {StepperStepProps} props - The props that the StepperStep component accepts.
 * @param {string} props.text - The text displayed next to the step icon.
 * @param {boolean} props.completed - Boolean which is true when the step has been completed in the past.
 * @param {boolean} props.active - Boolean which is true when the step is the current step.
 * @param {React.ReactNode} props.stepIcon - Icon to be displayed in the step circle in overview.
 * @constructor
 */
const StepperStep: FunctionComponent<StepperStepProps> = (props) => {
    const {text, completed, active, stepIcon} = props;
    return <div className={'stepper-step'}>
        <div className={`stepper-step-icon ${completed ? 'bg-main text-white' : (active ? 'text-main' : 'text-secondary')} ${!active && !completed ? 'border-secondary' : 'border-main'}`}>{completed ? <FontAwesomeIcon  icon={faCheck}/> : stepIcon}</div>
        <div className={'stepper-step-text'}>{text}</div>
    </div>;
}

export default StepperStep;